import React, { useEffect, useState } from 'react';

import Grid from '@mui/material/Grid2';

import { useMenuOption, ToggleFullScreenButton } from 'itaf';

import LineWidget from './SelicChart';
import SunburstChartWidget from './EmpresasChart';
import RegimeTributarioWidget from './RegimesChart';

import SpedService from '../../services/SpedService';

const DashboardContainer = () => {
  const [dashboardSelic, setDashboardSelic] = useState(false);
  const [dashboardCnpj, setDashboardCnpj] = useState(false);
  const [dashboardSped, setDashboardSped] = useState([]);
  
  const [isCnpjFullScreen, setCnpjFullScreen] = useState(false);
  const [isSelicFullScreen, setSelicFullScreen] = useState(false);
  const [isRegimesFullScreen, setRegimesFullScreen] = useState(false);

  const showSelic = dashboardSelic && !isCnpjFullScreen && !isRegimesFullScreen;
  const showEmpresas = dashboardCnpj && !isSelicFullScreen && !isRegimesFullScreen;
  const showRegimes = dashboardCnpj && !isCnpjFullScreen && !isSelicFullScreen;
  
  useEffect(() => {
    const dashboard = useMenuOption("DASHBOARD", "").menu;
    if (dashboard?.items) {
      dashboard?.items?.forEach((product) => {
        if (product.name === 'DASH_GR_SELIC') {
          setDashboardSelic(true);
        }
        if (product.name === 'DASH_GR_EMPR') {
          setDashboardCnpj(true);
        }
      });
    }
  }, []);
  
  function loadDashboardSpedData() {
    SpedService.fetchDashboardSpedData()
      .then(async (res) => {
        if (res.ok) {
          const body = await res.json();
          setDashboardSped(body);
        }
      });
  }
  
  const cnpjFullScreenButton = (
    <ToggleFullScreenButton 
      isFullScreen={isCnpjFullScreen}
      setIsFullScreen={setCnpjFullScreen}
    />
  );

  return (
    <Grid container spacing={4}>
      {showRegimes && 
        <RegimeTributarioWidget onFullScreen={setRegimesFullScreen}
        />
      }
      {showSelic &&
        <LineWidget onFullScreen={setSelicFullScreen}
        />
      }
      {showEmpresas && 
        <Grid size={{ sm: isCnpjFullScreen ? 12 : 6, xs: 12 }}>
          <SunburstChartWidget 
            height={isCnpjFullScreen ? `calc(100vh - 192px)` : 272} 
            fullScreenButton={cnpjFullScreenButton} 
          />
        </Grid>
      }
      {/* <Grid lg={2} md={4} sm={6} xs={12}>
        <Link href="/app/sped" underline="none" key="sped">
          <Widget title="Auditoria" data={dashboardSped} />
        </Link>
      </Grid> */}
    </Grid>
  );
};

export default DashboardContainer;
